
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1> 2nd G.H. Raisoni Memorial Rapid Chess Tournament, Gondia 2026

                    </h1>

				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <h2>2nd G.H. Raisoni Memorial Rapid Chess Tournament, Gondia 2026</h2>
        <p><strong>Date: </strong>21st June 2026</p>
        <p><strong>Venue: </strong>Vivek Mandir School, Gondia</p>
        <p><strong>Organized By: </strong>Gondia District Chess Association</p>
        <p><strong>In Association With: </strong>G.H. Raisoni Sports & Cultural Foundation, Nagpur, and the Kalpana
            Prakash Welfare Foundation, Nagpur</p>
        <p><strong>Tournament Director: </strong>Mr. Mukesh Barai, Secretary, Gondia District Chess Association</p>
        <p><strong>Chief Arbiter: </strong>SNA Sham Agrawal (FIDE ID: 25053558)</p>
        <p><strong>Format: </strong>8 Swiss League rounds, 15 minutes + 5 seconds increment from move one</p>
        <p><strong>Total Participation: </strong>198 players, including 52 FIDE-rated players</p>
        <p><strong>Prize Fund: </strong>₹40,000</p>
        <div class="row justify-content-between">
            <div class="col-md-12">
                <h5 class="primary-purple">A Celebration of Strategy, Talent, and Sportsmanship</h5>
                <p>The 2nd G.H. Raisoni Memorial Rapid Chess Tournament, Gondia 2026 was successfully organized on
                    21st June 2026 at Vivek Mandir School, Gondia. The championship was organized by the Gondia
                    District Chess Association in association with the G.H. Raisoni Sports & Cultural Foundation,
                    Nagpur and the Kalpana Prakash Welfare Foundation, Nagpur.</p>
                <p>The tournament was conducted under the leadership of Tournament Director Mr. Mukesh Barai,
                    Secretary, Gondia District Chess Association, while SNA Sham Agrawal (FIDE ID: 25053558)
                    officiated as the Chief Arbiter. The championship was played in 8 Swiss League rounds with a time
                    control of 15 minutes + 5 seconds increment from move one, ensuring exciting and competitive
                    games throughout the day.</p>

                <h5 class="primary-purple">Strong Participation from Across the Region</h5>
                <p>The championship witnessed an enthusiastic response with 198 players, including 52 FIDE-rated
                    players, participating from Gondia, Tumsar, Bhandara, Sakoli, and neighbouring regions of Madhya
                    Pradesh and Chhattisgarh. The event provided an excellent platform for students, young chess
                    enthusiasts, and experienced players to showcase their talent and gain valuable competitive
                    experience.</p>
                <p>A total prize fund of ₹40,000 was awarded to deserving winners across various categories, making
                    the tournament one of the prominent rapid chess events in the region.</p>

                <h5 class="primary-purple">Grand Inaugural Ceremony</h5>
                <p>The tournament was inaugurated by Hon'ble Dilip Jain, Director, Vivek Mandir School, Gondia, in
                    the presence of distinguished guests including Shiekha Piplewar, Executive Engineer; Vijay
                    Bahekar; P. N. Rao, Ex-Secretary, Chhattisgarh Chess Association; and Mukesh Barai, Executive
                    Member, Maharashtra Chess Association.</p>
                <p>The dignitaries appreciated the efforts of the organizers in promoting chess and emphasized the
                    importance of strategic thinking, discipline, patience, and sportsmanship among young players.
                </p>

                <h5 class="primary-purple">Prize Distribution Ceremony</h5>
                <p>The closing ceremony was graced by Shiekha Piplewar, P. N. Rao, Mukesh Barai, Prabhakar
                    Palandurkar, Rachana Rathi, Priya Lalit Agrawal, and Deepika Chhuttani, who felicitated the
                    winners and participants.</p>
                <p>In recognition of their enthusiastic participation, all 198 players were awarded participation
                    certificates and medals. The guests congratulated the winners and encouraged every participant
                    to continue pursuing excellence in chess with dedication and determination.</p>

                <h5 class="primary-purple">A Successful Sporting Initiative</h5>
                <p>The championship successfully fulfilled its objective of promoting chess at the grassroots level
                    while encouraging healthy competition, analytical thinking, and sportsmanship among youth. The
                    event also strengthened collaboration between chess associations, educational institutions, and
                    sports-promoting organizations.</p>

                <h5 class="primary-purple">Acknowledgements</h5>
                <p>The organizers extend their heartfelt gratitude to everyone who contributed to the success of the
                    tournament.</p>
                <p>Special thanks to:</p>
                <ul class="list-style list-style1">
                    <li>Vivek Mandir School, Gondia for providing excellent infrastructure and support.</li>
                    <li>G.H. Raisoni Sports & Cultural Foundation, Nagpur for its continued encouragement and
                        sponsorship in promoting chess across the region.</li>
                    <li>Kalpana Prakash Welfare Foundation, Nagpur for its valuable partnership and support.</li>
                    <li>Gondia District Chess Association, tournament officials, arbiters, volunteers, parents,
                        coaches, and all participants for their dedication and cooperation in making the championship
                        a grand success.</li>
                </ul>
                <p>The 2nd G.H. Raisoni Memorial Rapid Chess Tournament, Gondia 2026 concluded on a highly successful
                    note, leaving participants inspired and further strengthening the spirit of competitive chess in
                    Central India.</p>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Tournament Report</h4>
                            </div>
                        </div>
                    </div>
                    <iframe
                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/2nd-gondia-tournament-report.pdf"
                        width="100% " height="500px" frameborder="0"></iframe>
                </div>
            </div>
        </div>
            <section class="section section-sm fide-chesscompetition section-banner-bg-1">
                <div class="container">
                    <div class="border-line-sm"></div>
                    <div class="row row-cols-1 row-cols-md-2">


                        <div class="col">
                            <div class="gall-ery">
                                <div class="row">
                                    <div class="col-md-7">
                                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                                            <h4 class="fw-bold">Photos</h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="lightBox--gallery">
                                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-1.avif"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-1.avif">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-1.avif"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-2.avif"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-2.avif">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-2.avif"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-3.avif"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-3.avif">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-3.avif"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>
                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-4.avif"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-4.avif">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-4.avif"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="gall-ery">
                                <div class="widget_title inner-title gall-sys shadow-text-sm">
                                    <h4 class="fw-bold">Media Coverage</h4>
                                </div>
                                <div class="lightBox--gallery">
                                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                                        <li class="col"
                                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-media.avif"
                                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-media.avif">
                                            <a href="Javascript:void(0);">
                                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/chess-tour-gondia-media.avif"
                                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                                <div class="light-gallery-poster">
                                                    <img
                                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                                </div>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

    </div>

</section>
